<ng-container [ngSwitch]="color">
	<ng-container *ngSwitchCase="'WHITE'">
		<tk-lazy-image height="36" pathToImage="svg/loader-white.svg" width="36" />
	</ng-container>

	<ng-container *ngSwitchDefault>
		<tk-lazy-image height="36" pathToImage="svg/loader.svg" width="36" />
	</ng-container>
</ng-container>
